
import React from 'react';
import { component_tool } from '@/tool';
let { WizModal } = component_tool;
import { WizTableForm } from '@/containers/common'
//配置项
let componentName = 'messageTask'
import { LookOrgNodeCategory } from '@/components'

const columns = () => {
  let self = this
  return [
    {
      title: '业务类型',
      name: 'bizType',
      dataIndex: 'bizType',
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 15, codeName: '报名' },
        { code: 26, codeName: '直播' },
        { code: 30, codeName: '作业' },
        { code: 38, codeName: "任务" },
        { code: 12, codeName: '路径必修' },
        { code: 39, codeName: '路径' },
        { code: 2, codeName: '问卷' },
        { code: 36, codeName: '班级' },
      ],
      searchItem: {
        onChange: (form, value, e) => {
          form.resetFields(['links']);
        },
        type: 'select'
      },
      tableItem: {}
    },
    {
      title: "创建时间",
      name: "updateTime",
      dataIndex: "updateTime",
      tableItem: {}
    },

  ]
}

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns: columns(),
      searchBarProps: {
        collapse: false,
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        buttonSort: ['group',  'export',  'add'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { children: '新增', icon: 'plus', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/message/MessageTask/MessageTaskDetail',
                //record: { type: type }
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出组织', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['update'],
      rowOperateView: [
        {
          key: 'update',
          custom: true,
          params: { children: '编辑'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/message/MessageTask/MessageTaskDetail',
            }
          }
        }
      ]
    }
  }
}


const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
